import { supabaseClient } from "@/lib/supabase";
import { queryOptions, useQuery } from "@tanstack/react-query";

function getShockwaveLocations() {
	return supabaseClient
		.from("shockwave_locations")
		.select("*")
		.throwOnError()
		.then((result) => result.data);
}

export const shockwave_locations_key = ["shockwave-locations"];

export const shockwaveLocationsQueryOptions = () => {
	return queryOptions({
		queryKey: shockwave_locations_key,
		queryFn: async () => getShockwaveLocations(),
	});
};

export function useShockwaveLocationsQuery() {
	return useQuery(shockwaveLocationsQueryOptions());
}
